import angular from 'angular';
import config from './summaries.config';

import {AbsenceEmployees} from './employees/absence-employees.component';
import {PresenceStudents} from './students/presence-students.component';

import SummariesController from './summaries.controller';

import './summaries.scss';

/**
 * @desc Control Module initialize.
 *
 * @ngInject
 */
export default angular
  .module('app.modules.summaries', [])
  .component('absenceEmployeesComponent', AbsenceEmployees)
  .component('presenceStudentsComponent', PresenceStudents)
  .controller('SummariesController', SummariesController)
  .config(config)
  .name;
